import { render } from "./EditarDespedida.vue?vue&type=template&id=6649a84c&scoped=true"
import script from "./EditarDespedida.vue?vue&type=script&lang=js"
export * from "./EditarDespedida.vue?vue&type=script&lang=js"

import "./EditarDespedida.vue?vue&type=style&index=0&id=6649a84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6649a84c"]])

export default __exports__